import { render, staticRenderFns } from "./lazyblock_profile.vue?vue&type=template&id=f74db9b6&scoped=true"
import script from "./lazyblock_profile.vue?vue&type=script&lang=js"
export * from "./lazyblock_profile.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_profile.vue?vue&type=style&index=0&id=f74db9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74db9b6",
  null
  
)

export default component.exports